"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_MAPPER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var faCheckCircle_1 = require("@fortawesome/pro-solid-svg-icons/faCheckCircle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Text_1 = __importDefault(require("shared/components/Text"));
exports.STATUS_MAPPER = {
    pending: { color: '#D0D9DF', icon: pro_solid_svg_icons_1.faClock },
    success: { color: '#02AD6B', icon: faCheckCircle_1.faCheckCircle },
    error: { color: '#E85048', icon: pro_regular_svg_icons_1.faCircleXmark },
};
var Status = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'pending' : _b, message = _a.message;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", border: "1px solid ".concat(exports.STATUS_MAPPER[status].color), borderRadius: 0.75, px: 2.5, py: 1.5 }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: exports.STATUS_MAPPER[status].icon, color: exports.STATUS_MAPPER[status].color }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ pl: 3 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, fontWeight: 600, color: "riverstone" }, { children: "Status" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone" }, { children: message }))] }))] })));
};
exports.default = Status;
